import { Option } from '@components/FormInput';
import { ProductId, RolesWithProduct } from '@customTypes/api/Commons';
import { SpvDownline } from '@customTypes/Commons';
import FEATURE_FLAGS from '@src/constants/featureFlags';

const LOCALE_CONSTANTS = {
  LOCALE: 'id-ID',
  LOCALE_CURRENCY: 'IDR',
};

const SET_TARGET_TIME = {
  START_DATE: Number(import.meta.env.VITE_SET_TARGET_TIME_START_DATE),
  END_DATE: Number(import.meta.env.VITE_SET_TARGET_TIME_END_DATE),
  START_HOUR: Number(import.meta.env.VITE_SET_TARGET_TIME_START_HOUR),
  END_HOUR: Number(import.meta.env.VITE_SET_TARGET_TIME_END_HOUR),
};

const HIERARCHY_ACTION_ELIGIBLE_TIME = {
  START_DATE: Number(import.meta.env.VITE_HIERARCHY_ACTION_ELIGIBLE_START_DATE),
  END_DATE: Number(import.meta.env.VITE_HIERARCHY_ACTION_ELIGIBLE_END_DATE),
};

const SupervisorDataOf2W = 'KS';

const MAX_WIDTH_SM = '(max-width: 640px)';

const AGENT_TYPE_FOR_SETTINGS = {
  ACTIVE_AGENTS_WITH_ARE_UPLINE: 'active-agents-with-are-upline',
  ACTIVE_AGENTS_WITH_SPV_UPLINE: 'active-agents-with-spv-upline',
  ACTIVE_AGENTS_WITH_BM_UPLINE: 'active-agents-with-bm-upline',
  ACTIVE_AGENTS_WITH_NO_UPLINE: 'active-agents-with-no-upline',
  INACTIVE_AGENTS: 'inactive-agents',
  INACTIVE_AGENTS_WITH_RECOMMNENDATIONS: 'inactive-agents-with-recommendations',
};

const PERFORMANCE_TYPE: Record<string, string> = {
  THIS_MONTH: 'thisMonth',
  HISTORICAL: 'historical',
};

const PRODUCT_NAMES_BY_ID: Record<string, string> = {
  [ProductId['2W']]: 'Motor',
  [ProductId['4W']]: 'Mobil',
  [ProductId['PBF']]: 'PBF',
};

const PRODUCT_NAMES_BY_ID_TRANSLATED: Record<string, string> = {
  [RolesWithProduct['SPV.2W']]: 'commons.motorcycle',
  [RolesWithProduct['SPV.4W']]: 'commons.car',
  [RolesWithProduct['SPV.PBF']]: 'commons.pbf',
  [ProductId['2W']]: 'commons.motorcycle',
  [ProductId['4W']]: 'commons.car',
  [ProductId['PBF']]: 'commons.pbf',
};

const SPV_DOWNLINE_BY_PRODUCT_ID = {
  [RolesWithProduct['SPV.2W']]: SpvDownline.are,
  [RolesWithProduct['SPV.4W']]: SpvDownline.are,
  [RolesWithProduct['SPV.PBF']]: SpvDownline.bro,
  [RolesWithProduct['BM']]: SpvDownline.are,
  [RolesWithProduct['ABPM']]: SpvDownline.are,
  [RolesWithProduct['AM']]: SpvDownline.are,
  [RolesWithProduct['None']]: SpvDownline.are,
  [ProductId['2W']]: SpvDownline.are,
  [ProductId['4W']]: SpvDownline.are,
  [ProductId['PBF']]: SpvDownline.bro,
};

const PRODUCT_CODENAME_BY_PRODUCT_ID: Record<string, string> = {
  [RolesWithProduct['SPV.2W']]: '2W',
  [RolesWithProduct['SPV.4W']]: '4W',
  [RolesWithProduct['SPV.PBF']]: 'PBF',
  [ProductId['2W']]: '2W',
  [ProductId['4W']]: '4W',
  [ProductId['PBF']]: 'PBF',
};

const PRODUCT_OPTIONS: Option<string>[] = [
  {
    label: 'Car',
    value: ProductId['4W'],
  },
  {
    label: 'Motorcycle',
    value: ProductId['2W'],
  },
  {
    label: 'PBF',
    value: ProductId['PBF'],
  },
];

export const arePerfMetricsLabels = [
  'Sales Performance (NTF) (Rp)',
  'Contract',
  'Prospect',
  'BA Productive',
  'BA Active',
  'BA Register',
  'BA New',
];

const HISTORICAL_PERFORMANCE_FILTER_OPTIONS = [
  { label: 'last3Months', value: 3, disabled: false },
  { label: 'last6Months', value: 6, disabled: false },
  { label: 'last1Year', value: 12, disabled: false },
];

const FIREBASE_REMOTE_CONFIG = {
  SPV_COCKPIT_INCENTIVE_SK_NUMBER: 'SPV_COCKPIT_INCENTIVE_SK_NUMBER',
};

export {
  FEATURE_FLAGS,
  SupervisorDataOf2W,
  SET_TARGET_TIME,
  HIERARCHY_ACTION_ELIGIBLE_TIME,
  LOCALE_CONSTANTS,
  MAX_WIDTH_SM,
  AGENT_TYPE_FOR_SETTINGS,
  PERFORMANCE_TYPE,
  PRODUCT_CODENAME_BY_PRODUCT_ID,
  PRODUCT_NAMES_BY_ID,
  HISTORICAL_PERFORMANCE_FILTER_OPTIONS,
  PRODUCT_NAMES_BY_ID_TRANSLATED,
  SPV_DOWNLINE_BY_PRODUCT_ID,
  PRODUCT_OPTIONS,
  FIREBASE_REMOTE_CONFIG,
};
